import { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { usePublicForm } from 'hooks/module/Form';
import FullLoader from '../../Loader/FullLoader';
import { EQUIPMENT_REGISTRY_QR_PARAMS, QR_PARAMS } from 'constant/qrcode';
import { MODULE } from 'constant/globals';
import { BASE_EQUIPMENT_QR_PATH } from 'hooks/navigation/useAssetManagementNavigation';
import { BASE_QR_PATH } from 'hooks/navigation/useQRPageNavigation';
import { extractQueryParamsValue } from 'utils/queryParams';

export function NonUserRoute() {
  const { search } = useLocation();
  const { isAuthenticated, loading, isGuestUser, isRegisteredVariconUser } =
    useAuth();
  const {
    type,
    from_qr_code: isFromQr,
    equipment_id: equipmentId,
  } = useMemo(
    () =>
      extractQueryParamsValue(search, [
        QR_PARAMS.TYPE,
        EQUIPMENT_REGISTRY_QR_PARAMS.FROM_QR_CODE,
        EQUIPMENT_REGISTRY_QR_PARAMS.EQUIPMENT_ID,
      ] as const),
    [search],
  );

  const { getRequiredDataFromURL } = usePublicForm();
  const { fromQR, linkID, hasPrefill, formID, equipmentID } =
    getRequiredDataFromURL();

  const isEquipmentQRScan =
    isAuthenticated &&
    type === MODULE.EQUIPMENT_REGISTRY &&
    isFromQr === 'true' &&
    !!equipmentId;

  if (loading) return <FullLoader />;

  if (isEquipmentQRScan) {
    const destination = isGuestUser
      ? `${BASE_QR_PATH}/equipment-details/${equipmentId}`
      : `${BASE_EQUIPMENT_QR_PATH}/${equipmentId}`;

    return <Navigate to={destination} replace />;
  }

  if (isAuthenticated && fromQR && formID) {
    const equipmentParam = equipmentID ? `&equipment_id=${equipmentID}` : '';
    const basePath = isGuestUser
      ? `/forms-qr/add-response/${formID}`
      : `/forms/submissions/add-response/${formID}`;
    return (
      <Navigate
        to={`${basePath}?from_QR=${fromQR}&link_id=${linkID}&has_prefill=${hasPrefill}${equipmentParam}`}
        replace
      />
    );
  }

  return !isAuthenticated || isGuestUser || isRegisteredVariconUser ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace />
  );
}
